import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

import { SET_SHOW_PAUSED_MODAL } from 'containers/App/constants';
import DropdownButton from 'components/Button/DropdownButton/DropdownButton';
import APResponsiveDropdown from 'components/Dropdown/APResponsiveDropdown';
import { ProjectsDownloadModal } from './Projects.DownloadModal';
import './styles.scss';

/**
 * @description: ActionButton Component from Projects index.
 * @param {*}
 * @return {*}
 */
export const ProjectsActionButton = ({ showProjectModal }) => {
  const dispatch = useDispatch();
  const [showActionOptions, toggleActionDropdown] = useState(false);
  const [downloadIsOpen, setDownloadIsOpen] = useState(false);

  // const projects = useSelector((state) => state.projects?.activeProjects?.projects);
  const isPaused = useSelector((state) => state.global.userInfo.personas?.isPaused);
  // #TODO: Project downloads is broken so need to hide the option.
  const showDownload = false; // projects?.length > 0;

  const show = () => {
    toggleActionDropdown(!showActionOptions);
  };

  const dismiss = () => {
    toggleActionDropdown(false);
  };

  const createNewProject = () => {
    showProjectModal();
    dismiss();
  };

  const download = () => {
    setDownloadIsOpen(true);
    dismiss();
  };

  const showPaused = () => {
    dispatch({ type: SET_SHOW_PAUSED_MODAL, payload: true });
  };

  const renderActionMenu = () => {
    return (
      <>
        <button
          className={clsx(
            'action_buttons__button',
            'button--unstyled',
            'button--menu',
          )}
          onClick={createNewProject}
        >
          Add New Project
        </button>
        {showDownload && (
          <button
            className={clsx(
              'action_buttons__button',
              'button--unstyled',
              'button--menu',
              'download-link',
              'border-top',
            )}
            onClick={download}
          >
            Download
          </button>
        )}
      </>
    );
  };

  const trigger = (
    <DropdownButton className="button button--md button--action">
      <span className="visually-hidden--mobile">Actions</span>
      {showActionOptions ? (
        <MdKeyboardArrowUp size={16} />
      ) : (
        <MdKeyboardArrowDown size={16} />
      )}
    </DropdownButton>
  );

  if (isPaused) {
    return (
      <button
        className="button button--md button--action"
        onClick={showPaused}
      >
        <span className="visually-hidden--mobile">Actions</span>
        {showActionOptions ? (
          <MdKeyboardArrowUp size={16} />
        ) : (
          <MdKeyboardArrowDown size={16} />
        )}
      </button>
    );
  }

  return (
    <>
      <APResponsiveDropdown
        opened={showActionOptions}
        show={show}
        dismiss={dismiss}
        triggerButton={trigger}
      >
        {renderActionMenu()}
      </APResponsiveDropdown>
      <ProjectsDownloadModal
        downloadIsOpen={downloadIsOpen}
        dismiss={dismiss}
        setDownloadIsOpen={setDownloadIsOpen}
      />
    </>
  );
};
